module.exports = __webpack_public_path__ + "img/202501160402.c51e42a5.png";